var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRecord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.91,
    height: 18,
    viewBox: "0 0 18.91 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8A3C\\u660E\\u66F8\\u30A2\\u30A4\\u30B3\\u30F3",
    transform: "translate(0 -12.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_310",
    "data-name": "\\u30D1\\u30B9 310",
    d: "M429.674,129.991l-.686-.686a1.065,1.065,0,0,0-1.506,0l-.642.642,2.192,2.192.642-.641A1.066,1.066,0,0,0,429.674,129.991Z",
    transform: "translate(-411.076 -112.365)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_311",
    "data-name": "\\u30D1\\u30B9 311",
    d: "M264.082,176.419v2.192h2.192l5.413-5.413-2.192-2.192Z",
    transform: "translate(-254.329 -152.825)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_151",
    "data-name": "\\u9577\\u65B9\\u5F62 151",
    width: 6.191,
    height: 1.032,
    transform: "translate(4.473 17.121)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_152",
    "data-name": "\\u9577\\u65B9\\u5F62 152",
    width: 6.191,
    height: 1.032,
    transform: "translate(4.473 20.904)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_153",
    "data-name": "\\u9577\\u65B9\\u5F62 153",
    width: 3.783,
    height: 1.032,
    transform: "translate(4.473 24.687)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_312",
    "data-name": "\\u30D1\\u30B9 312",
    d: "M13.761,28.657a.288.288,0,0,1-.287.287H1.663a.288.288,0,0,1-.287-.287V13.983a.288.288,0,0,1,.287-.287H13.474a.288.288,0,0,1,.287.287v4.145l1.376-1.376V13.983a1.663,1.663,0,0,0-1.663-1.663H1.663A1.663,1.663,0,0,0,0,13.983V28.657A1.663,1.663,0,0,0,1.663,30.32H13.474a1.663,1.663,0,0,0,1.663-1.663v-4.6l-1.376,1.376Z",
    fill: "#28a0a0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRecord);
export default __webpack_public_path__ + "static/media/ico-record.1b2d12c79ab9c592b8388dc2e9d1c38d.svg";
export { ForwardRef as ReactComponent };